import { render, staticRenderFns } from "./ImportVerificationWorkItemsHeader.vue?vue&type=template&id=7496f169&lang=pug"
import script from "./ImportVerificationWorkItemsHeader.vue?vue&type=script&lang=js"
export * from "./ImportVerificationWorkItemsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports